import decodeAccessToken from './decode-access-token';
import getAccessToken from './get-access-token';
const checkIfLoggedIn = () => {
  const loggedState = {
    isLoggedIn: false,
    id: null
  };
  const token = getAccessToken();
  if (!token) return loggedState;
  const {
    exp,
    data = {}
  } = decodeAccessToken(token);
  if (!exp) return loggedState;
  const dateNow = new Date();
  const currentTime = dateNow.getTime() / 1000;
  if (exp < currentTime) return loggedState;
  const {
    user: {
      id
    } = {}
  } = data;
  return {
    isLoggedIn: true,
    id
  };
};
export default checkIfLoggedIn;
//# sourceMappingURL=check-if-logged-in.js.map